import EmployeeSalaryMenu from "./EmployeeSalaryMenu";

import styles from "../styles/Employee.module.css";

function EmployeeSalary({ getPage = () => { }, handleMenuChange = () => { } }) {
  return (
    <div >
      <EmployeeSalaryMenu onChange={handleMenuChange} />
      {/* {getPage()} */}
    </div>
  );
}

export default EmployeeSalary;
